var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignedforyourbusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(-142 -1710)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(142 1710)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "suitcase",
    transform: "translate(156.387 1724.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    d: "M17.108,7.855a1.3,1.3,0,0,1-1.3-1.3V4.6H10.6V6.554a1.3,1.3,0,1,1-2.6,0V4.6A2.6,2.6,0,0,1,10.6,2h5.2a2.6,2.6,0,0,1,2.6,2.6V6.554A1.3,1.3,0,0,1,17.108,7.855Z",
    transform: "translate(2.41)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3416",
    "data-name": "Path 3416",
    d: "M16.538,16.512a2.68,2.68,0,0,1-.924.156,2.851,2.851,0,0,1-1-.182L0,11.62v9.928a3.576,3.576,0,0,0,3.578,3.578H27.65a3.576,3.576,0,0,0,3.578-3.578V11.62Z",
    transform: "translate(0 2.897)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3417",
    "data-name": "Path 3417",
    d: "M31.229,8.578v2.98l-15.3,5.1a.963.963,0,0,1-.625,0L0,11.558V8.578A3.576,3.576,0,0,1,3.578,5H27.65A3.576,3.576,0,0,1,31.229,8.578Z",
    transform: "translate(0 0.904)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignedforyourbusiness);
export default __webpack_public_path__ + "static/media/designedforyourbusiness.6cc6bcb1a9ab9957f737ec9874356671.svg";
export { ForwardRef as ReactComponent };